<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="field-value">
      <div v-for="department of deptValues" :key="department">
        {{ department }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('departments', { departments: (state) => state.all }),
    deptValues() {
      if (!this.value || this.value.length === 0) return ['-']
      return this.value.map(
        (dept) =>
          `${this.departmentDisplayName(dept.deptId)} - ${
            dept.percentOwnership ? dept.percentOwnership + '%' : 'Not Set'
          }`
      )
    },
  },
  methods: {
    departmentDisplayName(deptId) {
      const dept = this.departments.find((el) => el.id === deptId)
      return dept.displayName || dept.name || deptId
    },
  },
}
</script>
